import 'fontsource-roboto';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';
import Firebase, { FirebaseContext } from './components/Firebase';
import './index.css';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <FirebaseContext.Provider value={new Firebase()}>
    <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
      <App />
    </SnackbarProvider>
  </FirebaseContext.Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
